import React, { useState } from 'react';
import { Menu } from '@mui/material';
import MenuItem from '@mui/material/MenuItem'
import ListItemText from '@mui/material/ListItemText';
import { ListItemIcon } from '@mui/material';
import Typography from '@mui/material/Typography';
import CopyAllIcon from '@mui/icons-material/CopyAll';


const CustomeDateInputBox = ({ cellIndex, rowIndex, cell, style, className, key, type, value, onChange, onMenuCopyToAllClick, disabled}) => {
  const [menuAnchor, setMenuAnchor] = useState(null);
 

  const handleContextMenu = (event) => {
    event.preventDefault();
    setMenuAnchor(event.currentTarget); 
  };


  const handleMenuCopyToAllClick = (event) => {
    if ( type === 'grid') {
      onMenuCopyToAllClick(cellIndex, rowIndex);
      handleCloseMenu();
    }
  }

  const handleCloseMenu = () => {
    setMenuAnchor(null); // Close the menu
  };

  return (
    <div>
    <input
        style={style}
        className={className}
        key={key}
        type='date'
        value={value}
        onChange={(e) => onChange(e, cellIndex, rowIndex, cell)}
        title={value}
        disabled={disabled}
        onContextMenu={type === 'grid' ? handleContextMenu : undefined}
    />

   {!disabled && <Menu
      anchorEl={menuAnchor}
      open={Boolean(menuAnchor)}
      onClose={handleCloseMenu}
    >
      { type === 'grid' && <MenuItem onClick={handleMenuCopyToAllClick}>
        <ListItemIcon >
              <CopyAllIcon fontSize="small"/>
        </ListItemIcon>
        <ListItemText>
          <Typography variant="body2" fontSize="small">
            Copy to All
          </Typography>
        </ListItemText>
      </MenuItem>
   }
    </Menu>
    }
  </div>
  );
};

export default CustomeDateInputBox;